import template from './order-history-line.html';

export const item = (name) => `
    <li class="order-history-line__item">
        ${name}
    </li>
`.trim();

export default template;
